import {
  CalendarCheck,
  CalendarDays,
  FlaskConical,
  Globe,
  Headphones,
  HeartHandshake,
  HeartPulse,
  MessageSquare,
  ShoppingCart,
  Smartphone,
  Stethoscope,
} from "lucide-react";
import AcaoModal from "../acaoModal";
import PeriodPill from "../periodPill";
import TT from "../tooltip";
import Zonas from "../zonas";
import {
  buildJourneyConfig,
  JOURNEY_STAGE_SHORT,
  JOURNEY_STAGES,
} from "../../constants/journeyStages";
import { normalizeKey } from "../../utils/normalizeString";

// --- Logo ---------------------------------------------------------------------
const LOGO =
  "data:image/png;base64,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";

// --- Apple-like design tokens -------------------------------------------------
const C = {
  // Unimed greens
  g900: "#003E1F",
  g800: "#005229",
  g700: "#006633",
  g600: "#008040",
  g500: "#00994D",
  g400: "#00B35A",
  g300: "#4DC87E",
  g200: "#B3E6C8",
  g100: "#E5F5EC",
  g50: "#F0FAF4",
  // 121 purple
  p700: "#3D2B9E",
  p600: "#5243C2",
  p500: "#7B6CF6",
  p400: "#A99DF9",
  p100: "#EEE9FF",
  // Neutrals - Apple style
  bg: "#F5F5F7",
  surface: "#FFFFFF",
  surf2: "#FAFAFA",
  surf3: "#F5F5F7",
  border: "#E8E8ED",
  border2: "#D2D2D7",
  text: "#1D1D1F",
  text2: "#3D3D3F",
  text3: "#6E6E73",
  text4: "#AEAEB2",
  // Semantic
  red: "#FF3B30",
  redBg: "#FFF5F5",
  orange: "#FF9500",
  orangeBg: "#FFFAF0",
  yellow: "#FFCC00",
  green: "#34C759",
  greenBg: "#F0FFF4",
  blue: "#007AFF",
  blueBg: "#F0F5FF",
  purple: "#AF52DE",
  purpleBg: "#F8F0FF",
  // Chart zones
  zCrit: "#FF3B3009",
  zWarn: "#FF950009",
  zOk: "#FFCC0009",
  zGood: "#34C75909",
  white: "#FFFFFF",
};
const F = {
  display:
    "-apple-system,BlinkMacSystemFont,'SF Pro Display','Helvetica Neue',sans-serif",
  text: "-apple-system,BlinkMacSystemFont,'SF Pro Text','Helvetica Neue',sans-serif",
  mono: "'SF Mono','Monaco','Cascadia Code','Roboto Mono',monospace",
};

// --- Short axis labels --------------------------------------------------------
// Derivado de constants/journeyStages.js (fonte única dos nomes das etapas).
const SHORT = JOURNEY_STAGE_SHORT;
const PER = {
  mensal: { label: "Março 2026", short: "Mar/26", ondas: 1, resp: 214 },
  trimestral: { label: "T1 2026", short: "T1/26", ondas: 3, resp: 612 },
  semestral: { label: "S2 2025", short: "S2/25", ondas: 2, resp: 1184 },
  anual: { label: "Ano 2025", short: "2025", ondas: 4, resp: 2384 },
};

// Journey cfg: CES Top2Box %, higher = better
// --- Journey stage icons (Lucide) --------------------------------------------
const STAGE_ICON_COMPONENTS = {
  ShoppingCart,
  HeartHandshake,
  CalendarDays,
  Stethoscope,
  CalendarCheck,
  FlaskConical,
  Headphones,
  Smartphone,
  Globe,
  HeartPulse,
  MessageSquare,
};
const JICONS = Object.fromEntries(
  JOURNEY_STAGES.map((s) => [s.label, STAGE_ICON_COMPONENTS[s.icon]]),
);

// Meta e Sist. Unimed de referência (mock) por etapa — os nomes e o tipo
// vêm de constants/journeyStages.js. Telas que mostram dado do cliente devem
// usar a meta e o benchmark da API, não estes valores.
const JCFG = buildJourneyConfig({
  vendas: { meta: 80, sys: 70 },
  boas_vindas: { meta: 82, sys: 72 },
  agend_consultas: { meta: 65, sys: 48 },
  consulta: { meta: 85, sys: 76 },
  agend_exames: { meta: 62, sys: 46 },
  exames: { meta: 72, sys: 65 },
  atend_operadora: { meta: 65, sys: 42 },
  aplicativo: { meta: 72, sys: 55 },
  portal: { meta: 68, sys: 50 },
  promocao_saude: { meta: 78, sys: 68 },
  comunicacao_op: { meta: 75, sys: 62 },
});
const META_NPS = 70,
  SYS_NPS = 52,
  UNIMED = "Unimed";

// --- 3 Pilares de CX (Sucesso, Esforço, Emoção) ------------------------------
const PILLAR_COLORS = {
  Sucesso: "#16a34a",
  Esforço: "#0284c7",
  Emoção: "#7c3aed",
};
const ESSENCE_TO_PILLAR = {
  sucesso: "Sucesso",
  esforço: "Esforço",
  esforco: "Esforço",
  effort: "Esforço",
  emoção: "Emoção",
  emocao: "Emoção",
  emotion: "Emoção",
  success: "Sucesso",
};
const METRIC_CATEGORY_TO_PILLAR = {
  ces: "Esforço",
  csat: "Sucesso",
  nps: "Emoção",
};
// essence vem do campo `drivers.essence` do banco; metricCategory é fallback para driver_metrics
const getPilarOf = (essence, metricCategory) => {
  const normalized = normalizeKey(essence);
  const fromEssence = ESSENCE_TO_PILLAR[normalized] || ESSENCE_TO_PILLAR[String(essence || "").toLowerCase().trim()];
  return fromEssence || METRIC_CATEGORY_TO_PILLAR[metricCategory] || null;
};

// --- Data ---------------------------------------------------------------------
const ESCALA = [
  {
    min: 80,
    color: "#059669",
    bg: "#ECFDF5",
    label: "✦ Excelente",
    st: "excelente",
  },
  {
    min: 70,
    color: "#16a34a",
    bg: "#F0FDF4",
    label: "✓ Muito Bom",
    st: "muitobom",
  },
  { min: 60, color: "#0284c7", bg: "#F0F9FF", label: "○ Bom", st: "bom" },
  {
    min: 50,
    color: "#d97706",
    bg: "#FFFBEB",
    label: "→ Atenção",
    st: "atencao",
  },
  { min: 40, color: "#dc2626", bg: "#FEF2F2", label: "↓ Ruim", st: "ruim" },
  {
    min: 0,
    color: "#991b1b",
    bg: "#FFF1F2",
    label: "✗ Crítico",
    st: "critico",
  },
];

function etSt(nome, val) {
  const found = ESCALA.find((e) => val >= e.min);
  return found || ESCALA[ESCALA.length - 1];
}

function moe(n) {
  const N = 50000;
  const z = 1.96;
  const p = 0.5;

  const margemErro = z * Math.sqrt(((p * (1 - p)) / n) * ((N - n) / (N - 1)));

  return Math.round(margemErro * 100 * 10) / 10;
}

function pctChk(arr) {
  return arr.length
    ? Math.round((arr.filter((c) => c.f).length / arr.length) * 100)
    : 0;
}

function diasRest(p) {
  return Math.ceil((new Date(p) - new Date()) / 86400000);
}

function fmtDt(s) {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y}`;
}

function todayStr() {
  return new Date().toISOString().split("T")[0];
}

// --- Conquistas (gamificação do Plano de Ação) --------------------------------
// Lista única de conquistas — usada tanto pelo grid de "Conquistas" (ActionPlanView)
// quanto pelo popup de "nova conquista desbloqueada" (wizard de conclusão, Dashboard).
// Cada `check` recebe o contexto agregado calculado por `getAchievementStats`.
function diasEntreCriacaoESucesso(a) {
  const criadoEm = (a.hist || [])
    .map((h) => h.dt)
    .filter(Boolean)
    .sort()[0];
  if (!criadoEm || !a.sucesso?.registradoEm) return Infinity;
  return Math.floor(
    (new Date(a.sucesso.registradoEm) - new Date(criadoEm)) / 86400000,
  );
}

function temSequenciaDeMeses(acoes, minimo) {
  const meses = [
    ...new Set(
      acoes
        .filter((a) => a.sucesso?.registradoEm)
        .map((a) => a.sucesso.registradoEm.slice(0, 7)), // "AAAA-MM"
    ),
  ].sort();
  let atual = meses.length ? 1 : 0;
  let maior = atual;
  for (let i = 1; i < meses.length; i++) {
    const [anoAnterior, mesAnterior] = meses[i - 1].split("-").map(Number);
    const [ano, mes] = meses[i].split("-").map(Number);
    const consecutivo =
      (ano === anoAnterior && mes === mesAnterior + 1) ||
      (ano === anoAnterior + 1 && mesAnterior === 12 && mes === 1);
    atual = consecutivo ? atual + 1 : 1;
    maior = Math.max(maior, atual);
  }
  return maior >= minimo;
}

function temMesPerfeito(acoes) {
  const porMes = {};
  acoes.forEach((a) => {
    const criadoEm = (a.hist || []).map((h) => h.dt).filter(Boolean).sort()[0];
    if (!criadoEm) return;
    const mes = criadoEm.slice(0, 7);
    (porMes[mes] ||= []).push(a);
  });
  return Object.values(porMes).some(
    (lista) => lista.length > 0 && lista.every((a) => a.status === "concluido" && a.sucesso),
  );
}

// Conquistas de sessão (boas-vindas, exploração de abas, primeira pergunta à
// Eva) não dependem de `acoes`/`coopPlanos` — são eventos de uso da própria
// plataforma, guardados em localStorage pra persistir entre sessões.
const ALL_TAB_IDS = [
  "executivo",
  "jornada",
  "tendencias",
  "segmentos",
  "drivers",
  "eva",
  "benchmark",
  "acoes",
  "coop",
  "quest",
];

function _lsGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function _lsSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // localStorage indisponível (modo privado etc.) — conquista de sessão
    // simplesmente não persiste, sem quebrar o app.
  }
}

function markWelcomed() {
  _lsSet("cx121_ach_bemvindo", "1");
}

function _visitedTabs() {
  const raw = _lsGet("cx121_visited_tabs");
  try {
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
}

function markTabVisited(tabId) {
  const visitados = _visitedTabs();
  visitados.add(tabId);
  _lsSet("cx121_visited_tabs", JSON.stringify([...visitados]));
}

function markEvaPergunta() {
  _lsSet("cx121_ach_eva_pergunta", "1");
}

const ACHIEVEMENT_DEFS = [
  // --- Primeiros passos ---------------------------------------------------
  {
    id: "first_acao",
    icon: "🌱",
    name: "Primeira Ação",
    desc: "Criou o primeiro plano de ação",
    cat: "Primeiros passos",
    check: (ctx) => ctx.acoes.length >= 1,
  },
  {
    id: "first_tarefa",
    icon: "✅",
    name: "Primeira Tarefa",
    desc: "Concluiu o primeiro item de um checklist",
    cat: "Primeiros passos",
    check: (ctx) => ctx.acoes.some((a) => (a.check || []).some((c) => c.f)),
  },
  {
    id: "detalhista",
    icon: "📝",
    name: "Detalhista",
    desc: "Registrou uma observação ao concluir um plano",
    cat: "Primeiros passos",
    check: (ctx) => ctx.acoes.some((a) => (a.sucesso?.observacao || "").trim()),
  },
  {
    id: "confiou_eva",
    icon: "🤖",
    name: "Confiou na Eva",
    desc: "Concluiu com sucesso um plano sugerido pela Eva",
    cat: "Primeiros passos",
    check: (ctx) =>
      ctx.acoes.some((a) => a.sucesso && (a.origem || "").toLowerCase().includes("eva")),
  },
  {
    id: "bem_vindo",
    icon: "🎬",
    name: "Bem-vindo(a)!",
    desc: "Primeiro acesso à plataforma",
    cat: "Primeiros passos",
    check: () => _lsGet("cx121_ach_bemvindo") === "1",
  },
  {
    id: "explorador",
    icon: "🔎",
    name: "Explorador",
    desc: "Visitou todas as abas do dashboard",
    cat: "Primeiros passos",
    check: () => _visitedTabs().size >= ALL_TAB_IDS.length,
  },
  {
    id: "primeira_pergunta_eva",
    icon: "💭",
    name: "Primeira Pergunta à Eva",
    desc: "Fez a primeira pergunta no chat da Eva",
    cat: "Primeiros passos",
    check: () => _lsGet("cx121_ach_eva_pergunta") === "1",
  },

  // --- CooperAção Unimed ---------------------------------------------------
  {
    id: "first_publicacao",
    icon: "🚀",
    name: "Primeira Publicação",
    desc: "Compartilhou o primeiro plano no CooperAção Unimed",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopPlanos.some((p) => p.unimed === UNIMED),
  },
  {
    id: "first_like_dado",
    icon: "👍",
    name: "Deu o Primeiro Like",
    desc: "Curtiu um plano de outra Unimed",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopCurtidas.size >= 1,
  },
  {
    id: "quebrou_gelo",
    icon: "💬",
    name: "Quebrou o Gelo",
    desc: "Comentou em um plano de outra Unimed",
    cat: "CooperAção Unimed",
    check: (ctx) =>
      ctx.coopPlanos.some((p) => (p.comentariosLista || []).some((c) => c.unimed === UNIMED)),
  },
  {
    id: "first_like_recebido",
    icon: "❤️",
    name: "Recebeu o Primeiro Like",
    desc: "Um plano seu foi curtido pela primeira vez",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopPlanos.some((p) => p.unimed === UNIMED && (p.curtidas || 0) > 0),
  },
  {
    id: "gerou_conversa",
    icon: "🗣️",
    name: "Gerou Conversa",
    desc: "Recebeu o primeiro comentário em um plano seu",
    cat: "CooperAção Unimed",
    check: (ctx) =>
      ctx.coopPlanos.some(
        (p) => p.unimed === UNIMED && (p.comentariosLista || []).some((c) => c.unimed !== UNIMED),
      ),
  },
  {
    id: "foi_reusado",
    icon: "🔁",
    name: "Foi Reusado",
    desc: "Outra Unimed reusou um plano seu",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopPlanos.some((p) => p.unimed === UNIMED && (p.reusos || 0) > 0),
  },
  {
    id: "compartilhador",
    icon: "🤝",
    name: "Compartilhador",
    desc: "Publicou 5 planos no CooperAção",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopPlanos.filter((p) => p.unimed === UNIMED).length >= 5,
  },
  {
    id: "inspirador",
    icon: "🌟",
    name: "Inspirador",
    desc: "Um plano seu foi bastante reusado por outras Unimeds",
    cat: "CooperAção Unimed",
    check: (ctx) => ctx.coopPlanos.some((p) => p.unimed === UNIMED && (p.reusos || 0) >= 3),
  },
  {
    id: "referencia_sistema",
    icon: "📣",
    name: "Referência do Sistema",
    desc: "Um plano seu passou de 20 curtidas + comentários",
    cat: "CooperAção Unimed",
    check: (ctx) =>
      ctx.coopPlanos.some(
        (p) =>
          p.unimed === UNIMED &&
          (p.curtidas || 0) + (p.comentariosLista || []).length >= 20,
      ),
  },

  // --- Impacto acumulado ---------------------------------------------------
  {
    id: "first",
    icon: "🥇",
    name: "Primeira Conquista",
    desc: "Registrou o primeiro sucesso",
    cat: "Impacto acumulado",
    check: (ctx) => ctx.numSucessos >= 1,
  },
  {
    id: "impact10",
    icon: "⭐",
    name: "10pp de Impacto",
    desc: "Acumulou 10pp de melhoria",
    cat: "Impacto acumulado",
    check: (ctx) => ctx.totalPp >= 10,
  },
  {
    id: "impact30",
    icon: "🏆",
    name: "30pp de Impacto",
    desc: "Acumulou 30pp de melhoria",
    cat: "Impacto acumulado",
    check: (ctx) => ctx.totalPp >= 30,
  },
  {
    id: "champion",
    icon: "💎",
    name: "Campeão CX",
    desc: "Acumulou 60pp de melhoria",
    cat: "Impacto acumulado",
    check: (ctx) => ctx.totalPp >= 60,
  },
  {
    id: "tacada_unica",
    icon: "💥",
    name: "Tacada Única",
    desc: "Um único plano gerou +50pp de ganho",
    cat: "Impacto acumulado",
    check: (ctx) => ctx.maxSingle >= 50,
  },

  // --- Consistência ---------------------------------------------------------
  {
    id: "maratonista",
    icon: "🎯",
    name: "Maratonista",
    desc: "Concluiu 10 planos de ação",
    cat: "Consistência",
    check: (ctx) => ctx.acoes.filter((a) => a.status === "concluido").length >= 10,
  },
  {
    id: "sequencia3",
    icon: "🔥",
    name: "Sequência de 3",
    desc: "3 meses seguidos com pelo menos um sucesso registrado",
    cat: "Consistência",
    check: (ctx) => temSequenciaDeMeses(ctx.acoes, 3),
  },
  {
    id: "mes_perfeito",
    icon: "📅",
    name: "Mês Perfeito",
    desc: "Concluiu com sucesso todos os planos abertos em um mês",
    cat: "Consistência",
    check: (ctx) => temMesPerfeito(ctx.acoes),
  },

  // --- Diversidade e velocidade ----------------------------------------------
  {
    id: "multi_driver",
    icon: "🌈",
    name: "Multi-driver",
    desc: "Sucesso registrado em 5 drivers diferentes",
    cat: "Diversidade e velocidade",
    check: (ctx) =>
      new Set(ctx.acoes.filter((a) => a.sucesso).map((a) => a.etapa)).size >= 5,
  },
  {
    id: "jornada_completa",
    icon: "🧭",
    name: "Jornada Completa",
    desc: "Sucesso em NPS, CSAT e CES",
    cat: "Diversidade e velocidade",
    check: (ctx) =>
      ["nps", "csat", "ces"].every((t) => ctx.acoes.some((a) => a.sucesso && a.tipo === t)),
  },
  {
    id: "zerador_vermelho",
    icon: "🚦",
    name: "Zerador de Vermelho",
    desc: "Tirou um driver da faixa crítica pra zona boa/excelente",
    cat: "Diversidade e velocidade",
    check: (ctx) =>
      ctx.acoes.some(
        (a) =>
          a.sucesso &&
          ["critico", "ruim"].includes(etSt(a.etapa, Number(a.v_baseline)).st) &&
          ["bom", "muitobom", "excelente"].includes(etSt(a.etapa, Number(a.v_atual)).st),
      ),
  },
  {
    id: "resolucao_rapida",
    icon: "⚡",
    name: "Resolução Rápida",
    desc: "Concluiu um plano com sucesso em menos de 30 dias",
    cat: "Diversidade e velocidade",
    check: (ctx) => ctx.acoes.some((a) => a.sucesso && diasEntreCriacaoESucesso(a) <= 30),
  },
  {
    id: "antecipador",
    icon: "⏰",
    name: "Antecipador",
    desc: "Concluiu um plano antes do prazo",
    cat: "Diversidade e velocidade",
    check: (ctx) =>
      ctx.acoes.some((a) => a.sucesso?.registradoEm && a.prazo && a.sucesso.registradoEm <= a.prazo),
  },
  {
    id: "plano_robusto",
    icon: "👥",
    name: "Plano Robusto",
    desc: "Concluiu um plano com 5+ tarefas no checklist",
    cat: "Diversidade e velocidade",
    check: (ctx) => ctx.acoes.some((a) => a.sucesso && (a.check || []).length >= 5),
  },
];

// Agrega os dados brutos (planos de ação + feed CooperAção) e resolve quais
// conquistas da lista acima já estão desbloqueadas.
function getAchievementStats(acoes = [], coopPlanos = [], coopCurtidas = new Set()) {
  const safeGanho = (v) => Math.min(200, Math.max(0, Number(v) || 0));
  const comSucesso = acoes.filter((a) => a.sucesso);
  const totalPp = comSucesso.reduce((s, a) => s + safeGanho(a.sucesso?.ganhoPp), 0);
  const numSucessos = comSucesso.length;
  const maxSingle = comSucesso.reduce((m, a) => Math.max(m, safeGanho(a.sucesso?.ganhoPp)), 0);
  const context = { acoes, coopPlanos, coopCurtidas, totalPp, numSucessos, maxSingle };
  const unlockedBadges = ACHIEVEMENT_DEFS.filter((b) => b.check(context));
  return { totalPp, numSucessos, maxSingle, unlockedBadges };
}

// --- PDF Export ---------------------------------------------------------------
function exportPDF() {
  const style = document.createElement("style");
  style.id = "print-style";
  style.textContent = `@media print{*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;}body{background:white!important;}.no-print{display:none!important;}@page{margin:1cm;size:A4;}}`;
  document.head.appendChild(style);
  window.print();
  setTimeout(() => document.head.removeChild(style), 1000);
}

// Opções para cada tipo de período (visual — labels intercambiáveis)
const PER_OPTIONS = {
  mensal: [
    "Abr/26",
    "Mar/26",
    "Fev/26",
    "Jan/26",
    "Dez/25",
    "Nov/25",
    "Out/25",
    "Set/25",
  ],
  trimestral: ["T2/26", "T1/26", "T4/25", "T3/25", "T2/25", "T1/25"],
  semestral: ["S1/26", "S2/25", "S1/25", "S2/24", "S1/24"],
  anual: ["2026", "2025", "2024", "2023", "2022"],
};
const PER_DEFAULT_LABELS = {
  mensal: "Mar/26",
  trimestral: "T1/26",
  semestral: "S2/25",
  anual: "2025",
};

const CES_COLS = [
  { k: "ef", c: "#059669", l: "Ext.Fácil" },
  { k: "f", c: "#34c759", l: "Fácil" },
  { k: "n", c: "#f59e0b", l: "Normal" },
  { k: "d", c: "#ef4444", l: "Difícil" },
  { k: "ed", c: "#dc2626", l: "Ext.Difícil" },
];
const CSAT_COLS = [
  { k: "ms", c: "#059669", l: "5 — Muito Satisfeito" },
  { k: "s", c: "#34c759", l: "4 — Satisfeito" },
  { k: "r", c: "#f59e0b", l: "3 — Razoável" },
  { k: "i", c: "#ef4444", l: "2 — Insatisfeito" },
  { k: "mi", c: "#dc2626", l: "1 — Muito Insatisfeito" },
];

// --- Action Plan flat list ---------------------------------------------------
const SC = {
  pendente: { label: "Pendente", color: "#FF9500" },
  em_andamento: { label: "Em andamento", color: "#007AFF" },
  concluido: { label: "Concluído", color: "#34C759" },
  cancelado: { label: "Cancelado", color: "#FF3B30" },
  arquivado: { label: "Arquivado", color: "#6B7280" },
};
const PC = {
  alta: { label: "Alta", color: "#FF3B30" },
  media: { label: "Média", color: "#FF9500" },
  baixa: { label: "Baixa", color: "#34C759" },
};

// --- Zonas de refer?ncia ------------------------------------------------------
const Z_CX = [
  [0, 40, "#99111108"], // Cr?tico
  [40, 50, "#dc262608"], // Ruim
  [50, 60, "#d9770608"], // Aten??o
  [60, 70, "#0284c708"], // Bom
  [70, 80, "#16a34a08"], // Muito Bom
  [80, 100, "#05966908"], // Excelente
];

// --- App ----------------------------------------------------------------------

export {
  AcaoModal,
  ACHIEVEMENT_DEFS,
  C,
  CES_COLS,
  CSAT_COLS,
  diasRest,
  ESCALA,
  etSt,
  exportPDF,
  F,
  fmtDt,
  getAchievementStats,
  getPilarOf,
  JCFG,
  JICONS,
  LOGO,
  markEvaPergunta,
  markTabVisited,
  markWelcomed,
  META_NPS,
  moe,
  PC,
  pctChk,
  PER,
  PER_DEFAULT_LABELS,
  PER_OPTIONS,
  PeriodPill,
  PILLAR_COLORS,
  SC,
  SHORT,
  SYS_NPS,
  todayStr,
  TT,
  UNIMED,
  Z_CX,
  Zonas,
};
